import { History, createBrowserHistory } from 'history';

export type ReadonlyBrowserHistory = History;
const browserHistory: ReadonlyBrowserHistory = createBrowserHistory();

export default browserHistory;
